import {EntityDescriptionElementDomainModel} from "./entity-description.element.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class EntityDescriptionElementViewModel extends BaseViewModel {
  constructor(model: EntityDescriptionElementDomainModel) {
    super(model);

    this.value = model.value;
  }

  get faqId(): String {
    let elementNumber = null;
    const isFaq = this.name.split("_").first() === "FAQ";

    if(isFaq) {
      const underscoreNumber = this.isCustomData ? 1 : 0;
      elementNumber = this.getSubstringFromEnd(this.name, underscoreNumber).substring(1);
    }

    return elementNumber;
  }

  get isCustomData(): Boolean {
    return this.name.endsWith("_CD");
  }

  getSubstringFromEnd(str, underscoreNum): String {
    const parts: Array<String> = str.split('_');
    const startIndex: Number = parts.length - underscoreNum;
    const isOffLimit: Boolean = startIndex <= 0;
    const subString: String = isOffLimit ? str : parts.slice(startIndex - 1).join('_');

    return subString;
  }
}
